import { CLEAR_PAGES, GET_PAGES, SET_PAGES_LOADING } from '../types';

const initialState = {
  pages: {},
  loading: true
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_PAGES:
      return {
        pages: payload,
        loading: false
      };
    case CLEAR_PAGES:
      return {
        pages: {},
        loading: false,
      };
    case SET_PAGES_LOADING:
      return {
        ...state,
        loading: payload
      };

    default:
      return state;
  }
}
